export function randomUuid(): string {
  if (!("randomUUID" in crypto)) {
    // @ts-expect-error polyfill crypto.randomUUID
    crypto.randomUUID = () =>
      // @ts-expect-error polyfill crypto.randomUUID
      ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16),
      );
  }
  return crypto.randomUUID();
}
